import {ATLASSIAN_PLUGIN_KEY} from "navigation-common/firebase-config";
import {ADMIN_MODULES} from "navigation-common/types/pages-constants";
import {AtlassianLocation} from "navigation-common/types/confluence-types";

export function isAdminLocation(location: AtlassianLocation) {
    return ADMIN_MODULES.some((module) => location.context.moduleKey === module.key);
}

export function handleLocationBasedInAppLink(adminModuleKey: string, generalModuleKey: string, customData: any) {
    AP.navigator.getLocation((location: any) => {
        AP.navigator.go("addonModule", {
            addonKey: ATLASSIAN_PLUGIN_KEY,
            moduleKey: isAdminLocation(location) ? adminModuleKey : generalModuleKey,
            customData
        });
    });
}
